import React, { useCallback, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import DefaultSidebar from "../shared/DefaultSidebar";
import DefaultHeader from "../shared/DefaultHeader";
import { useDispatch, useSelector } from "react-redux";
import DefaultAdminHeader from "../shared/DefaultAdminHeader";
import { profileDetails } from "../services/profileService";
import { userVerifyTokan } from "../services/frontService/Login";
import SidePanel from "../components/sections/AdminSection/MediaSidePanel";
import MediaSidePanel from "../components/sections/AdminSection/MediaSidePanel";

const MediaLayout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile.profileData.data);
  const settings = useSelector((state) => state?.settings?.data);
  const token = localStorage.getItem("auth_token");
  const [profileData, setprofileData] = useState(null);
  const [loaded, setloaded] = useState(true);
  const [topics, settopics] = useState([]);
  const [adminId, setAdminId] = useState();

  //   useEffect(() => {
  //     loadProfileDetails(setprofileData, setloaded).then((res) => {
  //       if (res?.data?.success) {
  //         setprofileData(res?.data?.docs);
  //         dispatch(setProfileDetails(res?.data?.docs));
  //       }
  //     });
  //   }, []);

  // function favIconChange() {
  //   let link = document.querySelector("link[rel~='icon']");
  //   if (!link) {
  //     link = document.createElement("link");
  //     link.rel = "icon";
  //     document.getElementsByTagName("head")[0].appendChild(link);
  //   }
  //   link.href = settings?.favicon?.url;
  // }
  // favIconChange();

  //   useEffect(() => {
  //     loadSiteSettingsDetails().then((res) => {
  //       if (res?.data?.status === 200) {
  //         dispatch(getSettings(res.data.data));
  //       }
  //     });
  //   }, []);

  const getAdminDetails = useCallback(() => {
    userVerifyTokan().then((res) => {
      if (res?.status === 200) {
        setAdminId(res?.data?.data?.id);
      }
    });
  }, []);

  useEffect(() => {
    getAdminDetails();
  }, [getAdminDetails]);

  const getDetails = useCallback(() => {
    if (adminId) {
      setprofileData({ loading: true, data: {} });
      profileDetails(adminId).then((res) => {
        if (res?.status === 200) {
          setprofileData({ loading: true, data: res?.docs });
        }
      });
    }
  }, [adminId]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  const loggedInUser = {
    name: profile?.name || profileData?.data?.name,
    // image: profile && profile?.image_name_url,
  };

  return (
    <>
      <div className="relative flex w-full h-screen overflow-hidden">
        <div
          className={
            "fixed h-screen flex transition-all duration-200 z-10 " +
            (isMenuOpen
              ? "-translate-x-full lg:translate-x-0 w-60 lg:w-16"
              : "translate-x-0 w-60 lg:w-60")
          }
        >
          <DefaultSidebar isMenuOpen={isMenuOpen} settings={settings} />
        </div>
        <div
          className={
            "relative w-full flex flex-col transition-all duration-200 " +
            (isMenuOpen ? "p-0 lg:pl-16" : "p-0 lg:pl-60")
          }
        >
          <DefaultAdminHeader
            isMenuOpen={isMenuOpen}
            setIsMenuOpen={setIsMenuOpen}
            userData={loggedInUser}
            isToggleIcon={true}
            siteData={"AdminPannel"}
          />
          <div className="relative w-full h-full max-h-[calc(100vh-4rem)] bg-slate-100 flex overflow-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaLayout;
